import { render, staticRenderFns } from "./SubGroupName.vue?vue&type=template&id=3bd8af69&scoped=true"
import script from "./SubGroupName.vue?vue&type=script&lang=js"
export * from "./SubGroupName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd8af69",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bd8af69')) {
      api.createRecord('3bd8af69', component.options)
    } else {
      api.reload('3bd8af69', component.options)
    }
    module.hot.accept("./SubGroupName.vue?vue&type=template&id=3bd8af69&scoped=true", function () {
      api.rerender('3bd8af69', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/groups/SubGroupName.vue"
export default component.exports